const storeCollection = [
  { label: 'Walmart', value: 1 },
  { label: 'Kroger', value: 2 },
  { label: 'CVS', value: 3 },
  { label: 'Dollar Store', value: 4 },
  { label: 'Target', value: 5 },
  { label: 'Albertsons', value: 6 },
  { label: 'Walgreens', value: 7 },
  { label: 'Safeway', value: 8 },
  { label: 'Amazon', value: 9 },
  { label: 'Publix', value: 10 },
  { label: 'Costco', value: 13 },
  { label: "Sam's Club", value: 14 },
  { label: "BJ's", value: 15 },
  { label: 'Stop & Shop', value: 16 },
  { label: 'Hannaford', value: 17 },
  { label: 'Food Lion', value: 18 },
  { label: 'Giant', value: 19 },
  { label: 'Other Grocer', value: 20 },
]

const genderOptions = [
  { label: 'Male', value: 'm' },
  { label: 'Female', value: 'f' },
  { label: 'Other', value: 'o' },
  { label: 'Prefer not to say', value: 'n' },
]

// these need to match the sign up form, BUT...
// The legacy site has a poor understanding of the relation of sex to gender
const nonWokeGenderOptions = [
  { label: 'Male', value: 'm' },
  { label: 'Female', value: 'f' },
  // .. the legacy site is not woke - it only understands male / female
  // if someone has one of those options they can't take those breaks, so we don't present them here
  // { label: "Other", value: "o" },
  // { label: "Prefer not to say", value: "n" },
]

export { storeCollection, genderOptions, nonWokeGenderOptions }
